// React and core libraries
import * as React from "react";
import {
  Routes,
  Route,
  Navigate,
  useParams,
  useSearchParams,
} from "react-router-dom";

// Internal components
import { ClusterLayout } from "./ClusterLayout";

// Relative imports (components from same directory)
import { InformationView } from "./Information";
import { InfrastructureView } from "./Infrastructure";
import { LifecycleView } from "./Lifecycle";
import { AnalyticsView } from "./Analytics";

// Internal utilities
import { Urls } from "../../domain/urls";

const IndexRedirect = () => {
  const { clusterId, accountSlug } = useParams();
  return (
    <Navigate
      to={`${Urls.Clusters}/${clusterId}/account/${accountSlug}/information`}
      replace
    />
  );
};

const LegacyClusterOverviewRedirect = () => {
  const [searchParams] = useSearchParams();
  const { clusterId } = useParams();

  let url = `/clusters/${clusterId}/information`;
  if (searchParams.get("account")) {
    url += `?account=${searchParams.get("account")}`;
  }

  return <Navigate to={url} replace />;
};

const LegacyClusterDetailsRedirect = () => {
  const [searchParams] = useSearchParams();
  const { clusterId } = useParams();

  let url = `/clusters/${clusterId}/infrastructure`;
  if (searchParams.get("account")) {
    url += `?account=${searchParams.get("account")}`;
  }

  return <Navigate to={url} replace />;
};

export const ClusterRouter = (): React.ReactElement => {
  return (
    <ClusterLayout>
      <Routes>
        <Route path="/" element={<IndexRedirect />} />
        <Route path="/lifecycle" element={<LifecycleView />} />
        <Route path="/infrastructure" element={<InfrastructureView />} />
        <Route path="/information" element={<InformationView />} />
        <Route path="/overview" element={<LegacyClusterOverviewRedirect />} />
        <Route path="/details" element={<LegacyClusterDetailsRedirect />} />
        <Route path="/analytics/:analyticsId" element={<AnalyticsView />} />
      </Routes>
    </ClusterLayout>
  );
};
